import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { LoadingService } from '@core/services/loading.service';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-daily-users',
  templateUrl: './daily-users.component.html',
  styleUrls: ['./daily-users.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DailyUsersComponent implements OnInit {
  public arrCoupons: any[] = [];
 
  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router , 
    private loading : LoadingService , 
    private language : LanguageService
  ) {} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;

 
  public levels: any[] = [];
  public tempData = [];
  public users = []
  public lang : any 

  @ViewChild(DatatableComponent) table: DatatableComponent;

 

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {
    this.language.getLanguage();

this.language.currentLang.subscribe((res: string) => {
  this.lang = res; 
});
    this.getAllUsers();
  }
  

/*----------  Get all users   ----------*/
getAllUsers() {
  this.loading.show();
  this.apisService.dailyUsers(this.currentPage).subscribe({ 
    next:(res) => {
        this.loading.hide()
        this.users = res.data
        console.log(this.users)
    },
    error:(err)=> {
      console.log('error in fetching', err)
      this.loading.hide()
    },
  }
  
  )
}


/*----------  Handling Image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }

  
  /*----------  Translating genders  ----------*/
  translateGender(gender) {
    if (gender == 'Male') {
      return 'ذكر';
    } else {
      return 'أنثى';
    }
  }
  


  

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }

  /*----------  Pagination Functions   ----------*/
next(){ 
  this.currentPage++
  this.getAllUsers()
}

prev(){ 
  this.currentPage--
  this.getAllUsers()
}

/*----------  Background color for gender  ----------*/
getRowClass = (row: any) => {
  return row.user_gender === 'Female' ? 'female-row' : '';
};
truncateMobile(value: string, limit: number = 15): string {
  if (!value) return '';
  return value.length > limit ? value.slice(0, limit) + '...' : value;
}

showFullMobile(mobile: string): void {
  if (!mobile) return;
  alert(mobile); // simple, clean, works everywhere
}


}
